export const handleDealerWebUrl = (rawDealerWebUrl: string | null) => {
  const trimmedUrl = rawDealerWebUrl?.trim();
  if (!trimmedUrl) return null;

  const url = urlWithProtocol(trimmedUrl);
  if (!isValidDealerUrl(url)) return null;

  return url;
};

function urlWithProtocol(url: string) {
  if (/^https?/.test(url)) {
    return url;
  }
  return "https://" + url;
}

function isValidDealerUrl(url: string) {
  try {
    // Checks basic format of a dealer URL, i.e. it must be a domain and have a TLD
    const looksLikeDealerUrl =
      /^https?:\/\/([-\w]+\.)+[a-z]{2,}(\/|#|\?|$)/.test(url);
    // Checks if the URL can be used as a URL object, which itself does some more validity checks
    const canBeUsedAsUrl = !!new URL(url);
    return looksLikeDealerUrl && canBeUsedAsUrl;
  } catch {
    return false;
  }
}
